import cn from 'classnames';
import { ReactElement } from 'react';
import { Button } from 'src/components/Button';

import s from './ProductHeroBlock.module.scss';

interface ProductHeroBlockProps {
  title: string;
  text?: string;
  list?: string[];
  footnote?: string;
  className?: string;
  classNameTitle?: string;
  classNameWrapper?: string;
  classNameList?: string;
  id?: string;
  formWrapperId?: string;
  formWrapperClassName?: string;
  titleSelectedColorText?: 'green' | 'purple';
  children?: ReactElement;
  buttonTitle?: string;
  onClickButton?: () => void;
}

export function ProductHeroBlock({
  title,
  text,
  titleSelectedColorText,
  list,
  footnote,
  id = '',
  formWrapperId = '',
  formWrapperClassName = '',
  className = '',
  classNameTitle = '',
  classNameWrapper = '',
  classNameList = '',
  children,
  buttonTitle,
  onClickButton,
}: ProductHeroBlockProps) {
  return (
    <section id={id} className={cn(s.root, className)} data-qa="section">
      <div className={cn(s.wrapper, classNameWrapper)}>
        <div className={s.content}>
          <h1
            className={cn(s.title, classNameTitle, {
              [s.green]: titleSelectedColorText === 'green',
              [s.purple]: titleSelectedColorText === 'purple',
            })}
            data-qa="section_hero_title"
            dangerouslySetInnerHTML={{ __html: title }}
          />
          {text && (
            <div
              className={s.text}
              data-qa="section_hero_text"
              dangerouslySetInnerHTML={{ __html: text }}
            />
          )}
          {list && (
            <ul
              className={cn(s.list, classNameList)}
              data-qa="section_hero_list"
            >
              {list.map((item, id) => (
                <li
                  className={s.listItem}
                  dangerouslySetInnerHTML={{ __html: item }}
                  key={id}
                />
              ))}
            </ul>
          )}
          {footnote && <p className={s.footnote}>{footnote}</p>}
          {buttonTitle && onClickButton && (
            <Button
              variant="primary"
              className={s.button}
              data-qa="modal-btn"
              onClick={onClickButton}
              id={`product-detail-ProductHero-button-modal-${buttonTitle}`}
              analyticsOptions={{
                action: 'click',
                clickZone: 'body',
                clickElement: 'button',
                clickContent: buttonTitle,
                uniqueId: `product-detail-ProductHero-button-modal-${buttonTitle}`,
                transitionType: 'inside-link',
              }}
            >
              {buttonTitle}
            </Button>
          )}
        </div>
        <div id={formWrapperId} className={formWrapperClassName}>
          {children}
        </div>
      </div>
    </section>
  );
}
